module.exports = __webpack_public_path__ + "static/2-fdb290bcea03d13147cf302a684338e9.jpg";